import React from 'react';
import { TextOptionProps } from '../../types';
import Card from '../common/Card';

const TextOption: React.FC<TextOptionProps> = ({
  text,
  isAI,
  position,
  onSelect,
  disabled,
}) => {
  // Simple click handler without delays or state
  const handleClick = () => {
    if (disabled) return;
    onSelect(isAI);
  };
  
  return (
    <Card
      onClick={handleClick}
      disabled={disabled}
      className={`h-full flex flex-col min-h-[200px] ${
        disabled ? 'opacity-70' : ''
      }`}
    >
      <div className="mb-4">
        <span className={`inline-block px-3 py-1 text-xs font-mono font-bold rounded-lg tracking-wider uppercase ${
          position === 'left'
            ? 'bg-gradient-to-r from-primary-500 to-primary-600 text-white shadow-neon'
            : 'bg-gradient-to-r from-secondary-500 to-secondary-600 text-white shadow-[0_0_10px_rgba(251,191,36,0.5)]'
        }`}>
          Sample {position === 'left' ? 'A' : 'B'}
        </span>
      </div>
      
      <div className="flex-grow">
        <p className="text-dark-200 leading-relaxed font-body text-sm sm:text-base">
          {text}
        </p>
      </div>
    </Card>
  );
};

export default TextOption;